import FetchImage from "@/components/core/fetch-image";
import { getProposalData } from "@/features/proposal/proposalSlice";
import { getRebookCancelPolicy } from "@/features/quote/quoteSlice";
import theme from "@/helpers/theme";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  Badge,
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import { useState } from "react";
import { useSelector } from "react-redux";
import { MUIButton } from "../core/material-ui";
import CustomModalDrawer from "../core/material-ui/custom-modal-drawer";
import { LOB } from "@/config/constants";

const MemberSelection = ({
  combineData,
  setCombineData,
  isEndorsedPolicy = false,
  lob = "health",
}) => {
  const [state, setState] = useState({ state: false });
  const rebookCancelPolicy = useSelector(getRebookCancelPolicy);
  const [showMore, setShowMore] = useState(isEmpty(rebookCancelPolicy));
  const isSmallScreen = useMediaQuery("(max-width: 600px)");
  const proposalData = useSelector(getProposalData);
  const disabledMember = proposalData.memberDetails?.map((member) => {
    return member.relationship;
  });

  const sonCount = disabledMember?.filter((relation) =>
    relation.startsWith("Son")
  ).length;
  const daughterCount = disabledMember?.filter((relation) =>
    relation.startsWith("Daughter")
  ).length;

  // In Addition of Son and daughter. User should not be able to delete member, For other cases we are disabling member
  const handleUpdateSelected = (id, action, count, memberCount = 0) => {
    const updatedRelationShip = [...combineData];
    const selectedObject = updatedRelationShip.find((obj) => obj.id === id);
    if (action) {
      if (action == "memberCount") {
        count === 0
          ? isEndorsedPolicy
            ? memberCount > 0
              ? ""
              : ((selectedObject.isSelected = !selectedObject.isSelected),
                (selectedObject.count = count))
            : ((selectedObject.isSelected = !selectedObject.isSelected),
              (selectedObject.count = count))
          : isEndorsedPolicy
          ? count <= memberCount
            ? (selectedObject.count = memberCount)
            : (selectedObject.count = count)
          : (selectedObject.count = count);
      } else if (action === "increment") {
        if (lob === LOB.PA) {
          selectedObject.count < 5
            ? (selectedObject.count += 1)
            : selectedObject.count;
        } else {
          selectedObject.count < 3
            ? (selectedObject.count += 1)
            : selectedObject.count;
        }
      } else {
        isEndorsedPolicy
          ? selectedObject.count === memberCount && memberCount !== 0
            ? ""
            : selectedObject.count > 1
            ? (selectedObject.count -= 1)
            : ((selectedObject.isSelected = !selectedObject.isSelected),
              (selectedObject.count = 0))
          : selectedObject.count > 1
          ? (selectedObject.count -= 1)
          : ((selectedObject.isSelected = !selectedObject.isSelected),
            (selectedObject.count = 0));
      }
    } else {
      if (selectedObject.count) {
        selectedObject.count < 1 ? (selectedObject.isSelected = true) : "";
      } else {
        if (selectedObject.isSelected) {
          selectedObject.isSelected = false;
        } else {
          if (["Son", "Daughter"].includes(selectedObject.relation)) {
            selectedObject.count = 1;
          }
          selectedObject.isSelected = true;
        }
      }
    }
    setCombineData(updatedRelationShip);
  };
  return (
    <Grid
      container
      rowSpacing={1}
      columnSpacing={{ xs: 1, md: !isEmpty(rebookCancelPolicy) ? 6 : 3 }}
      sx={{ px: { xs: "1rem", md: "0rem" } }}
    >
      {combineData
        .slice(0, showMore ? 8 : combineData.length)
        .map(({ id, relation, multiple, isSelected, count }) => {
          return (
            <Grid
              item
              {...(isEmpty(rebookCancelPolicy) ? { xs: 4, sm: 3, lg: 3 } : {})}
              key={id}
            >
              <Box
                component={"div"}
                disabled={isEndorsedPolicy}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Button
                  component="div"
                  disableRipple
                  disabled={
                    isEndorsedPolicy && !["Son", "Daughter"].includes(relation)
                      ? disabledMember.includes(relation)
                      : lob === LOB.PA && relation === "Self" && isSelected
                      ? true
                      : false
                  }
                  sx={{
                    border: isSelected
                      ? `0.25rem solid ${theme.palette.color.aigColor17}`
                      : "",
                    borderRadius: "50%",
                    width: isEndorsedPolicy
                      ? { xs: "5rem", sm: "3.75rem" }
                      : { xs: "5rem", sm: "6.25rem" },
                    height: isEndorsedPolicy
                      ? {
                          xs: "5rem",
                          sm: "3.75rem",
                        }
                      : { xs: "5rem", sm: "6.25rem" },

                    opacity:
                      isEndorsedPolicy &&
                      !["Son", "Daughter"].includes(relation)
                        ? disabledMember.includes(relation)
                          ? "0.3"
                          : "1"
                        : "1",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleUpdateSelected(id);
                    multiple &&
                      setState((prevState) => ({
                        ...prevState,
                        [id]: { state: true },
                      }));
                  }}
                >
                  {multiple && isSelected && (
                    <Button
                      variant="aig-primary"
                      type="button"
                      onClick={(e) => e.stopPropagation()}
                      sx={{
                        position: "absolute",
                        zIndex: "1",
                        bottom: -5,
                        minWidth: "4.75rem",
                        height: isEndorsedPolicy ? "1rem" : "1.5rem",
                        fontSize: "0.75rem",
                        display: { xs: "none", sm: "flex" },
                        backgroundColor: "color.aigColor17",
                        ":hover": { backgroundColor: "color.aigColor17" },
                        borderRadius: "1.125rem",
                      }}
                      startIcon={
                        <RemoveIcon
                          onClick={(e) => {
                            // e.stopPropagation();
                            isEndorsedPolicy
                              ? ["Son", "Daughter"].includes(relation)
                                ? relation === "Son"
                                  ? handleUpdateSelected(
                                      id,
                                      "decrement",
                                      0,
                                      sonCount
                                    )
                                  : handleUpdateSelected(
                                      id,
                                      "decrement",
                                      0,
                                      daughterCount
                                    )
                                : handleUpdateSelected(id, "decrement")
                              : handleUpdateSelected(id, "decrement");
                          }}
                        />
                      }
                      endIcon={
                        <AddIcon
                          onClick={(e) => {
                            // e.stopPropagation();
                            handleUpdateSelected(id, "increment");
                          }}
                        />
                      }
                    >
                      {count}
                    </Button>
                  )}
                  {isSmallScreen && multiple && isSelected && (
                    <CustomModalDrawer
                      anchor="bottom"
                      isModalRequired={false}
                      open={state?.[id]?.state || false}
                      width="30%"
                      hasDrawerCloseButton={true}
                      modalHeader={`Select the numbers of ${relation}`}
                      onClose={(e) => {
                        e.stopPropagation();
                        setState((prevState) => ({
                          ...prevState,
                          [id]: { state: false },
                        }));
                      }}
                      drawerSx={{ p: 3, display: { xs: "block", sm: "none" } }}
                    >
                      <Box
                        sx={{
                          borderTopRightRadius: "1rem",
                        }}
                      >
                        <Box display={"flex"}>
                          {Array.from(
                            { length: lob === LOB.PA ? 6 : 4 },
                            (_, i) => i
                          ).map((item) => {
                            return (
                              <Typography
                                key={item}
                                variant="aigBodyL"
                                fontWeight="fontWeightMedium"
                                sx={{
                                  mt: 2,
                                  p: "0.75rem 1.5rem",
                                  backgroundColor:
                                    count === item ? "color.aigColor17" : "",
                                  cursor: "pointer",
                                  borderRadius: "2.5rem",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setState((prevState) => ({
                                    ...prevState,
                                    [id]: { state: false },
                                  }));
                                  isEndorsedPolicy
                                    ? ["Son", "Daughter"].includes(relation)
                                      ? relation === "Son"
                                        ? handleUpdateSelected(
                                            id,
                                            "memberCount",
                                            item,
                                            sonCount
                                          )
                                        : handleUpdateSelected(
                                            id,
                                            "memberCount",
                                            item,
                                            daughterCount
                                          )
                                      : handleUpdateSelected(
                                          id,
                                          "memberCount",
                                          item
                                        )
                                    : handleUpdateSelected(
                                        id,
                                        "memberCount",
                                        item
                                      );
                                }}
                              >
                                {item}
                              </Typography>
                            );
                          })}
                        </Box>
                      </Box>
                    </CustomModalDrawer>
                  )}

                  {/* for Desktop Screen  */}
                  <FetchImage
                    relationship={relation}
                    sx={{
                      display: { xs: "none", sm: "block" },
                      width: isEndorsedPolicy ? 62 : 72,
                      height: isEndorsedPolicy ? 62 : 72,
                    }}
                  />
                  {/* for Mobile Screen */}
                  <Badge
                    sx={{
                      display: { xs: "block", sm: "none" },
                    }}
                    color="success"
                    badgeContent={count}
                  >
                    <FetchImage
                      sx={{
                        width: 60,
                        height: 60,
                      }}
                      relationship={relation}
                    />
                  </Badge>
                </Button>

                <Typography
                  component={"div"}
                  mt={0.5}
                  sx={{
                    typography: { xs: "aigBodyS", md: "aigBodyM" },
                    fontWeight: "fontWeightRegular",
                    textAlign: "center",
                  }}
                >
                  {relation}
                </Typography>
              </Box>
            </Grid>
          );
        })}

      {isEmpty(rebookCancelPolicy) && combineData.length > 8 && (
        <Grid item xs={12}>
          <MUIButton
            sx={{
              fontWeight: "500",
              fontSize: "1rem",
              color: "color.aigColor1",
            }}
            type={"button"}
            onClick={() => {
              setShowMore(!showMore);
            }}
          >
            {showMore
              ? isSmallScreen
                ? "View More Members"
                : "More Members"
              : isSmallScreen
              ? "View Less Members"
              : "Less Members"}
          </MUIButton>
        </Grid>
      )}
    </Grid>
  );
};

MemberSelection.propTypes = {
  combineData: PropTypes.array,
  isEndorsedPolicy: PropTypes.bool,
  setCombineData: PropTypes.func,
  lob: PropTypes.string,
};

export default MemberSelection;
